import * as React from 'react'

import type { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/timeoff/pages/employee/RootPage'))

const EditLeavePage = React.lazy(() => import('modules/timeoff/pages/employee/EditLeavePage'))
const EditMedicalLeavePage = React.lazy(
  () => import('modules/timeoff/pages/employee/EditMedicalLeavePage')
)
const EditMedicalLeaveUpdatePage = React.lazy(
  () => import('modules/timeoff/pages/employee/EditMedicalLeaveUpdatePage')
)
const NewLeavePage = React.lazy(() => import('modules/timeoff/pages/employee/NewLeavePage'))
const NewMedicalLeaveUpdatePage = React.lazy(
  () => import('modules/timeoff/pages/employee/NewMedicalLeaveUpdatePage')
)
const RejectLeavePage = React.lazy(() => import('modules/timeoff/pages/employee/RejectLeavePage'))

const employeesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.employees.id.timeOff.path,
      element: <RootPage />,
      children: [
        {
          path: navigation.employees.id.timeOff.leavesNew.path,
          element: <NewLeavePage />,
        },
        {
          path: navigation.employees.id.timeOff.leavesEditLeaveId.path,
          element: <EditLeavePage />,
        },
        {
          path: navigation.employees.id.timeOff.leavesRejectLeaveId.path,
          element: <RejectLeavePage />,
        },
        {
          path: navigation.employees.id.timeOff.leaveUpdatesLeaveIdEditMedicalLeave.path,
          element: <EditMedicalLeavePage />,
        },
        {
          path: navigation.employees.id.timeOff.leaveUpdatesLeaveIdNew.path,
          element: <NewMedicalLeaveUpdatePage />,
        },
        {
          path: navigation.employees.id.timeOff.leaveUpdatesLeaveIdEditLeaveUpdateId.path,
          element: <EditMedicalLeaveUpdatePage />,
        },
      ],
    },
  ]
}

export default employeesRoutes
